import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Gym } from "../gym/types";
import { CategoryManager } from "./CategoryManager";
import { ItemManager } from "./ItemManager";
import { TimeSlotManager } from "./TimeSlotManager";
import { ReservationOverview } from "./ReservationOverview";

interface ReservationManagementProps {
  gym: Gym;
}

export const ReservationManagement = ({ gym }: ReservationManagementProps) => {
  const [activeTab, setActiveTab] = useState("categories");

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold">Gestión de Reservas - {gym.name}</h3>
        <p className="text-sm text-muted-foreground">
          Administra las categorías, elementos y horarios de reserva de tu gimnasio
        </p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="categories">Categorías</TabsTrigger>
          <TabsTrigger value="items">Elementos</TabsTrigger>
          <TabsTrigger value="timeslots">Horarios</TabsTrigger>
          <TabsTrigger value="overview">Reservas</TabsTrigger>
        </TabsList>

        <TabsContent value="categories" className="space-y-4">
          <CategoryManager gymId={gym.id} />
        </TabsContent>

        <TabsContent value="items" className="space-y-4">
          <ItemManager gymId={gym.id} />
        </TabsContent>

        <TabsContent value="timeslots" className="space-y-4">
          <TimeSlotManager gymId={gym.id} />
        </TabsContent>

        <TabsContent value="overview" className="space-y-4">
          <ReservationOverview gymId={gym.id} />
        </TabsContent>
      </Tabs>
    </div>
  );
};